// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1moRk","footer":"ModalFilter_footer__2LvFi"};